import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useAtomValue, useSetAtom } from 'jotai';

// Hooks
import useCheckResults from '@/utils/hooks/giveaway-picker/useCheckResults';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Routes
import { GIVEAWAY_PICKER_RESULT } from '@/lib/routes/apiToolsEndpoints';

// Components
import Button from '@/components/base/Button';
import H1 from '@/components/base/Headings/H1';
import { emailAtom } from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms';
import {
    giveawayCheckResultsUrlAtom,
    giveawayDrawIdAtom,
    giveawayResultSignatureAtom
} from '@/components/pages/giveaway-picker/Atoms/resultsAtom';
// Atoms
import { currentStepAtom } from '@/components/pages/giveaway-picker/Atoms/stepsAtoms';
import CheckEmail from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/DrawInProgress/CheckEmail';
import { Trans } from '@/components/tools/translation';
import { JellycoLoader as Loader } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/DrawInProgress/components/JellycoLoader';

export const DrawInProgress = () => {
    const router = useRouter();
    const { t } = useTranslation('giveaway_picker');

    const currentStep = useAtomValue(currentStepAtom);
    const email = useAtomValue(emailAtom);
    const checkResultUrl = useAtomValue(giveawayCheckResultsUrlAtom);
    const drawId = useAtomValue(giveawayDrawIdAtom);
    const setResultSignature = useSetAtom(giveawayResultSignatureAtom);
    const { giveawayResultsData } = useCheckResults(checkResultUrl);

    useEffect(() => {
        if (currentStep !== 4 || !checkResultUrl) return;

        if (giveawayResultsData?.result_signature) {
            setResultSignature(giveawayResultsData.result_signature);
            router.push(
                `${GIVEAWAY_PICKER_RESULT}?id=${drawId}&signature=${giveawayResultsData.result_signature}`
            );
        }
    }, [currentStep, checkResultUrl, giveawayResultsData, router]);

    if (currentStep !== 4 || !checkResultUrl) return null;

    if (giveawayResultsData?.message === 'check-email') return <CheckEmail />;

    return (
        <div
            className="mx-auto flex h-full max-w-150 flex-col items-center justify-center gap-8"
            data-testid="draw-in-progress">
            <Loader />
            <div className="flex flex-col items-center gap-10 text-center">
                <H1>{t('draw_in_progress.title')}</H1>
                <p className="font-GMedium text-xl text-icoGray-500">
                    <Trans
                        i18nKey="giveaway_picker:draw_in_progress.description"
                        values={{ email }}
                        components={{ semibold: <span className="font-GSemiBold" /> }}
                    />
                </p>
            </div>
            <Button onClick={() => window.location.reload()}>
                {t('draw_in_progress.start_again_button')}
            </Button>
        </div>
    );
};
